import React from 'react';
import VoucherPage from './VoucherPage';

const MailhostingPage: React.FC = () => {
  return <VoucherPage category="mailhosting" />;
};

export default MailhostingPage;
